// extracted by mini-css-extract-plugin
export default {"list":"About_list__yHSa2","listitem":"About_listitem__nxRmd"};